import { Schema } from '@/includes/definitions/index.d';
import wordsSchema from '@/includes/db/schemas/words.schema';
import CardGameHistorySchema from '@/includes/db/schemas/card-game-history.schema';
import ArticleGameHistorySchema from '@/includes/db/schemas/article-game-history.schema';
import WordsListSchema from '@/includes/db/schemas/words-list.schema';
import AnkiGameHistorySchema from '@/includes/db/schemas/anki-game-history.schema';
import AnkiScheduleSchema from '@/includes/db/schemas/anki-schedule.schema';

export default [
  wordsSchema, CardGameHistorySchema, ArticleGameHistorySchema, WordsListSchema,
  AnkiGameHistorySchema, AnkiScheduleSchema,
] as Schema[];
